<template>
  <div class="min-h-screen bg-gray-50 py-10 px-4">
    <!-- Title -->
    <p class="text-gray-600 text-center max-w-6xl mx-auto mb-10">
        Halaman ini berisi informasi resmi mengenai pengumuman lelang dan eksekusi hak tanggungan.
    </p>

    <!-- Grid Cards -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
        <a
            v-for="(item, index) in reports"
            :key="index"
            :href="item.filepath"
            target="_blank"
            class="group bg-white cursor-pointer shadow-lg rounded-2xl flex flex-col items-center justify-center text-center 
                transition-all duration-300 ease-out transform aspect-[1/1.2] p-6
                hover:translate-y-1 hover:shadow-md active:translate-y-2 active:shadow-sm"
        >
            <!-- PDF Icon -->
            <mdicon name="file-certificate-outline" size="100" class="text-gray-400"></mdicon>

            <!-- Title -->
            <p class="text-xl font-semibold mt-6 mb-6 text-gray-700">
            {{ item.title }}
            </p>

            <!-- Download Button -->
            <span
            class="border-primary border-2 text-primary group-hover:bg-primary group-hover:text-white 
                    px-6 py-2 rounded-xl font-medium transition-colors duration-300"
            >
            Unduh
            </span>
        </a>
    </div>

  </div>
</template>

<script>
export default {
  name: "ReportGrid",
  data() {
    return {
      reports: [],
      type : 'Pengumuman Lelang'
    };
  },
  methods: {
    getData() {
      this.$store.commit("ChangeLoader", true);
      this.axios
        .get(`/api/regulation/type/${this.type}`)
        .then((response) => {
          this.reports = response.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.$store.commit("ChangeLoader", false);
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="css" scoped>

</style>
